import { Controller, useFormContext } from "react-hook-form";
import React from "react";
import clsx from "clsx";
const RadioInput = (props) => {
    var _a;
    const value = (_a = props.value) !== null && _a !== void 0 ? _a : props.label;
    const { control, formState: { errors } } = useFormContext(); // useFormContext to get the methods from parent
    return (React.createElement(Controller, { name: props.name, control: control, render: ({ field }) => (React.createElement("div", { className: "form-check", onMouseEnter: () => props.onHover && props.onHover(value), onMouseLeave: () => props.onHover && props.onHover(null) },
            React.createElement("input", Object.assign({ className: clsx("form-check-input", props.className, { "is-invalid": errors && errors[props.name] }), id: props.id, type: "radio" }, field, { value: value, checked: field.value === value, onChange: () => field.onChange(value) })),
            React.createElement("label", { className: "form-check-label", htmlFor: props.id }, props.label))) }));
};
export default RadioInput;
